/* eslint-disable react-hooks/exhaustive-deps */
import { Collapse } from "@blueprintjs/core"
import chroma from 'chroma-js'
import { Fragment, useEffect, useState } from "react"
import { Color, ID } from "src/libs/interfaces/layouts"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { __, CSSObjectToString, getContrastColor } from "src/libs/utilities"
import { ALIGN, ILanding, ILandingSection } from "src/modules/pe-landing-module/data/interfaces"
import { components } from "src/modules/pe-landing-module/data/utils/components"
import { useComposition } from "src/modules/pe-landing-module/hooks/useComposition"
import "../../../../assets/css/accordeon.scss"
import __cross from "../../../../assets/img/cross.svg"
import { HTML as _HTML } from "../../contentType"
import DataDummy from "../../landing-edit/DataDummy"
import { IDataComponentsProps } from "../DataComponents"
import { setHorizontalAlignToCSSRule } from "../Section" 
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import { DataContentAnimateContainer } from "./DataContentAnimateContainer"
import { DataContentPositionContainer } from "./DataContentPositionContainer"

/* Protopia Ecosystem component */
export interface ISectionAccordeonProps extends IDataComponentsProps {
   
}
const SectionAccordeon = (props: ISectionAccordeonProps): JSX.Element => {
    const setColors = (): Color[] => {
        const colors = section.haccordeon_design?.isNoBackground
            ?
            [  "#FFFFFF00", "#FFFFFF00"  ]
            :
            section.haccordeon_design?.cardColors || section.cardColors || ["#e1e1e1", "#6b6b6b"]
        return chroma.scale( colors ).colors(props.data.length)
    }
    
    const [section, setSection] = useState<ILandingSection>(props.section)    
    useEffect(() => {
        const unsubscribe = useLandingStore.subscribe(
            ( state: ILandingStore ) => state.currentLanding,
            ( currentLanding:ILanding ) => { 
                const sec: ILandingSection = currentLanding.sections.find(s => s.id === props.section.id)!                            
                if( JSON.stringify( sec ) !== JSON.stringify( section ) ) { 
                    setSection(() => {
                        return sec
                    })
                }
            }, 
            {} 
        )
        return () => {
            unsubscribe();
        };
    }, [])  
    const composition = useComposition( section )
    const [cardsColor, setCardsColor] = useState<Color[]>( setColors() )
    const [accOpen, setAccOpen] = useState<ID>()
    
    useEffect(() => {
        setCardsColor( setColors() )
    }, [props.data, section.cardColors])

    useEffect(() => {
        setAccOpen( section.data[0]?.id)
    }, [])

    useEffect(() => {
        const cw            = !!section.haccordeon_design?.cover_width ? section.haccordeon_design?.cover_width : 40
        const cover_width   = `height: ${cw}px!important;
            min-height: ${cw}px!important;
            max-height: ${cw}px!important; ` 
        const labelSize = section.haccordeon_design?.label_size ? section.haccordeon_design.label_size : 14
        addCSSClass(
            `section-accordeon-container-${section.id}`,
            `.section-accordeon-container-${section.id} {
                ${setHorizontalAlignToCSSRule(section.vertical_align || ALIGN.MIDDLE )};
            }
            .section-accordeon-container-${section.id} .landing-accordeon-item-container {
                ${ CSSObjectToString( section.haccordeon_design?.container || {} ) } 
            }
            .section-accordeon-container-${section.id} .landing-accordeon-item {
                ${ CSSObjectToString( section.haccordeon_design?.card || {} ) }
                ${ cover_width } 
            }
            .section-accordeon-container-${section.id} .landing-accordeon-cover {
                ${ CSSObjectToString( section.haccordeon_design?.card_cover || {} ) }
                ${ cover_width } 
            }
            .section-accordeon-container-${section.id} .landing-accordeon-cover:before {
                ${ CSSObjectToString( section.haccordeon_design?.card_cover_before || {} ) }
                ${ cover_width } 
            }
            .section-accordeon-container-${section.id} .landing-accordeon-cover:after {
                ${ CSSObjectToString( section.haccordeon_design?.card_cover_after || {} ) }
                ${ cover_width } 
            }

            .section-accordeon-container-${section.id} .landing-accordeon-cross {
                ${ CSSObjectToString( section.haccordeon_design?.card_icon || {}, true ) }
            }
            .section-accordeon-container-${section.id} .landing-accordeon-cross > span > img {
                height: ${section.haccordeon_design?.icon_size ? section.haccordeon_design.icon_size : 32}px!important;
            }
            .section-accordeon-container-${section.id} .landing-accordeon-title {
                margin-left: ${ (cw - labelSize) / 2 }px;
                ${ CSSObjectToString( section.haccordeon_design?.card_label || {}, true ) }
                font-size: ${ labelSize }px!important;
            } 
            .section-accordeon-container-${section.id} .landing-accordeon-content-container {
                ${ CSSObjectToString( section.haccordeon_design?.content_container || {}, true ) }
            }
            .section-accordeon-container-${section.id} .landing-accordeon-content-container:after {
                ${ CSSObjectToString( section.haccordeon_design?.content_container_after || {}, true ) }
            }
            .section-accordeon-container-${section.id} .landing-accordeon-content-container:before {
                ${ CSSObjectToString( section.haccordeon_design?.content_container_before || {}, true ) }
            }
            `
        )
        return () => {
            removeCSSClass( `section-accordeon-container-${section.id}` )
        }
    }, [ section ])
    return <div 
        className={`landing-data-components-container  ${section.className || ""} landing-edit-cont landing-section-accordeon section-accordeon-container-${section.id}`}
         style={{...section.dstyle, }} 
        data-proportia={composition.proportia.join(",")}
    >
       {
            props.data.map((data, i) => { 
                if(data.isHidden) {
                    return <DataDummy key={ data.id } data={data} section={section} />
                }
                const type = data.type
                const DataComponent = type && components()[ type ]
                    ?
                    components()[ type ].c
                    :
                    _HTML  
                return <div className="landing-accordeon-item-container" key={ data.id }>
                    <div 
                        className={`landing-accordeon-item ${accOpen === data.id ? "open" : ""}`} 
                        style={{ backgroundColor: cardsColor[i], color: getContrastColor( cardsColor[i] )  }}
                        onClick={ () => setAccOpen( data.id ) } 
                    >
                        <div className="landing-accordeon-cover d-flex justify-content-between w-100 align-items-center pr-3">
                            <div 
                                className="landing-accordeon-title py-2 px-2 letter-spacing-2 small text-uppercase"
                                dangerouslySetInnerHTML={{ __html : data.title || data.defaultTitle || __( components()[ type ].title ) + " " + data.id }}
                            /> 
                            <div className="landing-accordeon-cross">
                                <span>
                                    <img 
                                        src={ __cross }
                                        alt=""
                                        height={ 8 }
                                    />
                                </span>
                            </div>
                        </div>
                    </div>
                    <Collapse  className="w-100" isOpen={ data.id === accOpen } >
                        <div className="landing-accordeon-content-container py-2">
                            <DataContentAnimateContainer {...props} i={ i } proportia={ !!composition.proportia ? composition.proportia[i] : 100 / composition.columns }>
                                <DataContentPositionContainer { ...props } i={ i } >
                                    <DataComponent  
                                        section={ section } 
                                        data={ { ...data, type } } 
                                    /> 
                                </DataContentPositionContainer>
                            </DataContentAnimateContainer>  
                        </div>
                    </Collapse>
                </div>
            })
        }
    </div>
}
export default SectionAccordeon